import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Widget from '../../../../components/Widget/Widget';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import CtaButton from '../../../../commons/ctaButton';
import { useStyles as useSharedStyles } from '../styles';
import { useStyles } from './checkoutSuccess.styles';

function ConnectCheckoutSuccess () {
    const sharedClasses = useSharedStyles();
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const { email, planName } = (location.state || {});

    return (
        <div>
            <div className={classes.header}>
                <CheckCircleOutlineOutlinedIcon className={classes.checkIcon} aria-hidden="true" />
                <p className={classes.subtitle}>
                    Payment confirmed
                </p>
                <h1 className={classes.heading}>
                    Welcome to Connect
                </h1>
                <p className={classes.body}>
                    {planName ? `${planName} ` : ''}Payment received. Time to Connect — pick an integration and set up your first magical workflow!
                </p>
            </div>

            <div className={`${sharedClasses.widgetContainer} ${classes.nextStepContainer}`}>
                <Widget buttonFlag={false} disableWidgetMenu inheritHeight bodyClass={classes.nextStepBody}>
                    <div className={classes.nextStepRow}>
                        <div className={classes.nextStepContent}>
                            <p className={classes.nextStepLabel}>Next step</p>
                            <div className={classes.nextStepInner}>
                                <div>
                                    <p className={classes.stepTitle}>Set up your integration</p>
                                    <p className={classes.stepDescription}>
                                        Browse all available integrations — we recommend starting with the one your marketing team uses most.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <CtaButton kind="primary" className={classes.ctaButton} onClick={() => history.push('/admin/analytics/connect')}>
                            Browse Integrations
                        </CtaButton>
                    </div>
                </Widget>
            </div>
        </div>
    );
}

export default ConnectCheckoutSuccess;
